import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from '@app/@core/services/http.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { environment } from '@env/environment.sandbox';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DecisionRolePageService {

  private api = 'http://localhost:3000/licenses';
  private apiUrl = environment.apiHost;

 constructor(private readonly http: HttpClient,
    private readonly httpservice: HttpService
  ) { }

  getLicenseReview(): Observable<any[]> {
    return this.http.get<any[]>(`${this.api}/review`);
  }
   getDecisionStatusHistory(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/decisionstatushistory?applicationid=${applicationid}`);
  }
  getLicenseRequirements(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/license-requirements-applicationid?applicationid=${applicationid}`);
  }
  updateApplicationStatus(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/decisionTabStatusUpdate`,obj);
  }

  resolveLicenseProvision(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/resolve-license-provision`, obj);
  }

  generatePdf(htmlContent: string): Observable<Blob> {
    const url = `${this.apiUrl}/document/html-to-pdf`;
    const body = { content: htmlContent };

    return this.http.post(url, body, {
      responseType: 'blob'
    });
  }
   createLicenseRequirements(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/save-license-requirements-applicationid`,obj);
  }

  updateLicenseRequirements(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/update-license-requirements-applicationid`,obj);
  }


  getRequirementDescription(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/getreqdescription?applicationid=${applicationid}`);
  }

   createLicKindProvisions(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/save-license-kind-endo-provisions`,obj);
  }

  getLicKindProvisions(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/license-kind-endo-provisions?applicationid=${applicationid}`);
  }

  createLicEndoProvisions(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/save-license-kind-endo-provisions`,obj);
  }

   getLicEndoProvisions(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/license-kind-endo-provisions?applicationid=${applicationid}`);
  }

  updateLicKindProvisions(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/update-license-kind-endo-provisions`,obj);
  }

  deleteLicKindProvisions(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/delete-license-kind-endo-provisions`,obj);
  }

  deleteLicRequirements(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/delete-license-requirements-applicationid`,obj);
  }

  getLastLicensenumber(): Observable<any> {
    return this.httpservice.get(`/application-flow/getlastlicenseno`);
  }

  getLicenseKindEndoDetails(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/license-kind-endorsements-applicationid?applicationid=${applicationid}`);
  }

  addLicenseKindEndoDetails(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/save-license-kind-endorsements-applicationid`,obj);
  }

  getDeficicencyComments(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/deficiency-comments?applicationid=${applicationid}`);
  }

  updateDefCommentsById(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/update-def-comments`,obj);
  }

    downloadDeficiency(obj: any): Observable<any> {
    return this.httpservice.post(`/application-flow/n8n-caller`,obj);
  }

   provtypechange(value: any): Observable<any> {
    return this.httpservice.get(`/application-flow/provtype?lookupcatid=${value}`);
  }

  getEndorsementsByLicenseKind(licenseKind: string) {
     return this.httpservice.get(`/platform/master/lookup/category/LICENSE-ENDORSEMENT?parent=${licenseKind}`);

}

  deleteNote(noteId: number): Observable<any> {
    return this.httpservice.delete(`/application-flow/delete-note?noteId=${noteId}`);
  }
   notifiction(data: any) {
    return this.httpservice.post(API_ENDPOINTS.notifiction, data);
  }
    getLicenseDatesByPersonId(personId: any): Observable<any> {
    return this.httpservice.get(`/application-flow/existinglicissuedatebypersonid?personId=${personId}`);
  }
  getLicenseByPersonId(personId: any): Observable<any> {
    return this.httpservice.get(`/application-flow/existinglicbypersonid?personId=${personId}`);
  }

  getLicenseByApplicationId(applicationId: any): Observable<any> {
    return this.httpservice.get(`/application-flow/rcr-license-kind-endorsements-applicationid?applicationid=${applicationId}`);
  }
  updatePublishLicenseByAppId(applicationId: any): Observable<any> {
    return this.httpservice.get(`/application-flow/updatepublishStatus?applicationid=${applicationId}`);
  }

  removeApplicationHighlight(obj: { section_name: string; user_id: number; application_id: number }): Observable<any> {
    return this.httpservice.post(`/application-flow/remove-application-highlight`, obj);
  }

  getValidationStatusForDeficicency(payload: any): Observable<any> {
    return this.httpservice.post(`/application-flow/deficiency-validation-status`, payload );
  }

   getDeficicencyDocuments(applicationid: any): Observable<any> {
    return this.httpservice.get(`/application-flow/get/documents/${applicationid}`);
  }
updateEndorsementStatusChange(payload: { applicationId: any; fromStatus: any; toStatus: string }) {
  return this.httpservice.post('/application-flow/update-endorsementstatuschange', payload);
}
}


